import { render } from "./HomeNews.vue?vue&type=template&id=d0411a28&scoped=true"
import script from "./HomeNews.vue?vue&type=script&lang=js"
export * from "./HomeNews.vue?vue&type=script&lang=js"

import "./HomeNews.vue?vue&type=style&index=0&id=d0411a28&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0411a28"]])

export default __exports__